import { useEffect, useState } from "react";
import { GetAllIncentive } from "../../services/incentive";

const ViewUserIncentive=()=>{
 const [incentiveData, setIncentiveData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await GetAllIncentive();
                const data = response.data;
                console.log(data);
                if (response.statusCode === 200 && response.success === true) {
                    setError("");
                    setIncentiveData(data);
                }
                else {
                    setError("something went wrong");
                }
            } catch (error) {

                console.log(error);
                setError(error.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);
    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">List User Incentive</h4>
                </div>
                <div>
                    
                </div>
                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                            {/* Total Records */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">
                                    Total Records:
                                    <span className="badge bg-primary ms-2">
                                        {incentiveData.length}
                                    </span>
                                </h5>
                               
                               
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>User Name</th>
                                            <th>Order Status</th>
                                            <th>Amount</th>
                                            <th>Percentage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {incentiveData.length > 0 ? (
                                            incentiveData.map((user, index) => (
                                                <tr key={user.userId}>
                                                    <td>{index + 1}</td>
                                                    <td>{user.userName}</td>
                                                    <td>
                                                        {user.orderStatus}
                                                    </td>
                                                    <td>
                                                        {user.amount || 0}
                                                    </td>
                                                    <td>
                                                        {user.percentage || 0}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    className="text-center"
                                                >
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
export default ViewUserIncentive;